<template>
    <Modal title="查看调拨单" v-model="showForm" :mask-closable="false" width="1000px">
        <div class="divider">调拨信息</div>
        <Form ref="viewForm" label-colon :label-width="150">
            <Row>
                <Col span="12">
                    <FormItem label="调拨单号" prop="orderNumber">
                        {{viewForm.orderNumber}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="资产数量" prop="quantity">
                        {{viewForm.quantity}}
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="调拨时间" prop="operatorTime">
                        {{this.$moment(viewForm.operatorTime).format('YYYY-MM-DD')}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="审批状态" prop="approvalStatus">
                        <div :style="{color: viewForm.approvalStatus === 0 ? '#ff9900' : (viewForm.approvalStatus === 1 ? '#ed4014' : '#19be6b')}">
                            {{viewForm.approvalStatus === 0 ? '审批中' : (viewForm.approvalStatus === 1 ? '驳回' : '通过')}}
                        </div>
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="调入人" prop="inOperatorName">
                        {{viewForm.inOperatorName}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="调出人" prop="outOperatorName">
                        {{viewForm.outOperatorName}}
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="调入部门资产管理员" prop="inDeptAssetAdminName">
                        {{viewForm.inDeptAssetAdminName}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="调出部门资产管理员" prop="outDeptAssetAdminName">
                        {{viewForm.outDeptAssetAdminName}}
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="调入部门负责人" prop="inStoremanName">
                        {{viewForm.inStoremanName}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="调出部门负责人" prop="outStoremanName">
                        {{viewForm.outStoremanName}}
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="调入人部门" prop="inOperatorDeptName">
                        {{viewForm.inOperatorDeptName}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="备注" prop="memo">
                        {{viewForm.memo}}
                    </FormItem>
                </Col>
            </Row>
            <Row>
                <Col span="12">
                    <FormItem label="创建人" prop="createName">
                        {{viewForm.createName}}
                    </FormItem>
                </Col>
                <Col span="12">
                    <FormItem label="创建时间" prop="createTime">
                        {{this.$moment(viewForm.createTime).format('YYYY-MM-DD HH:mm:ss')}}
                    </FormItem>
                </Col>
            </Row>
        </Form>
        <div v-if="approverList.length !== 0">
            <div class="divider">审核信息</div>
            <Form class="plain-form" label-colon :label-width="90">
                <Steps direction="vertical" :current="approverList.length-1">
                    <Step :title="item.psName + '：' + item.approverName" v-for="item in approverList" :key="item.id">
                        <div slot="content">
                            审核状态：
                                <span :style="{color: item.approvalStatus === 0 ? '#ff9900' : (item.approvalStatus === 1 ? '#ed4014' : '#19be6b')}">
                                    {{item.approvalStatus === 0 ? '审核中' : (item.approvalStatus === 1 ? '驳回' : '通过')}}
                                </span>，
                            审核时间：{{item.approvedTime}}，
                            审核意见：{{item.approvalComment ? item.approvalComment : '无'}}
                        </div>
                    </Step>
                </Steps>
            </Form>
        </div>
        <div class="divider">资产信息</div>
        <div class="table">
            <div class="table-list">
                <Table stripe :columns="columns" :data="dataList">
                </Table>
            </div>
        </div>
        <div slot="footer">
            <Button type="primary" @click="closeModal(false)">确定</Button>
        </div>
    </Modal>
</template>

<script>
import { reqGetInfoByAllocateId } from '../../../../api/asset-api';

export default {
    name: 'viewAllocate',
    props: {
        value: {
            type: Boolean,
            default: false
        },
        allocateId: ''
    },
    data() {
        return {
            showForm: false,
            viewForm: {
                orderNumber: '',
                outStoremanName: '',
                outOperatorName: '',
                operatorTime: '',
                inStoremanName: '',
                inOperatorName: '',
                inOperatorDeptName: '',
                approvalStatus: '',
                quantity: 0,
                createName: '',
                createTime: '',
                memo: ''
            },
            columns: [
                {
                    title: '资产编码',
                    key: 'encoding',
                    tooltip: 'ture',
                    minWidth: 200
                },
                {
                    title: '资产名称',
                    key: 'assetName',
                    tooltip: 'ture',
                    width: 150
                },
                {
                    title: '资产分类',
                    key: 'classifyName',
                    tooltip: 'ture',
                    width: 100
                },
                {
                    title: '品牌',
                    key: 'brand',
                    tooltip: 'ture',
                    width: 100
                },
                {
                    title: '型号',
                    key: 'model',
                    tooltip: 'ture',
                    width: 150
                },
                {
                    title: 'SN码',
                    key: 'snCode',
                    tooltip: 'ture',
                    width: 100
                },
                {
                    title: '所在位置',
                    key: 'locationName',
                    tooltip: 'ture',
                    width: 150
                }
            ],
            dataList: [],
            approverList: [],
        }
    },
    watch: {
        value(val) {
            this.showForm = val;
        },
        showForm(val) {
            if (val) {
                reqGetInfoByAllocateId({id: this.allocateId}).then(res => {
                    this.dataList = res.data.data[0].assetList;
                    this.viewForm = res.data.data[0];
                    this.approverList = res.data.data[0].approverList;
                });
            } else {// 反之则关闭页面
                this.closeModal(val);
            }
        }
    },
    methods: {
        closeModal(val) {
            this.$emit('input', val);
        }
    },
    mounted() {
    }
}
</script>
